import React from 'react';

import ProfilePicture from 'components/profile_picture';
import TimeMessageLogo from 'components/widgets/icons/time_message_logo';

import * as PostUtils from 'utils/post_utils';
import * as Utils from 'utils/utils';

import {type Post} from 'mattermost-redux/types/posts';
import {type UserProfile} from 'mattermost-redux/types/users';
import {type UserStatus} from '@time-webkit/all/types/general';

type Props = {
    availabilityStatusOnPosts: string;
    compactDisplay: boolean;
    isRHS?: boolean;
    post: Post;
    status?: UserStatus;
    user?: UserProfile;
    isBot?: boolean;
    overrideUsername?: string;
    overrideIconURL?: string;
    onProfilePopoverOpen?: () => void;
    onProfilePopoverClose?: () => void;
}

export default class PostProfilePicture extends React.PureComponent<Props> {
    static defaultProps: Partial<Props> = {
        status: 'offline',
    };

    getProfilePictureURL = (): string => {
        const {post, user} = this.props;

        if (user && user.id === post.user_id) {
            return Utils.imageURLForUser(user.id, user.last_picture_update);
        } else if (post.user_id) {
            return Utils.imageURLForUser(post.user_id, Date.now());
        }

        return '';
    };

    getStatus = (fromAutoResponder: boolean, fromWebhook: boolean, user?: UserProfile) => {
        if (fromAutoResponder || fromWebhook || user?.is_bot) {
            return undefined;
        }

        return this.props.status;
    };

    getPostIconURL = (defaultURL: string): string => {
        if (this.props.compactDisplay) {
            return '';
        }

        return this.props.overrideIconURL || defaultURL;
    };

    render() {
        const {
            availabilityStatusOnPosts,
            overrideUsername,
            overrideIconURL,
            compactDisplay,
            isRHS,
            post,
            user,
            isBot,
        } = this.props;

        const isSystemMessage = PostUtils.isSystemMessage(post);
        const fromWebhook = PostUtils.isFromWebhook(post);

        if (isSystemMessage && !compactDisplay && !fromWebhook && !isBot) {
            return <TimeMessageLogo className='icon'/>;
        }
        const fromAutoResponder = PostUtils.fromAutoResponder(post);

        const hasMention = !fromAutoResponder && !fromWebhook;
        const profileSrc = this.getProfilePictureURL();
        const src = this.getPostIconURL(profileSrc);

        const overrideIconEmoji = post.props ? post.props.override_icon_emoji : '';
        const isEmoji = typeof overrideIconEmoji == 'string' && overrideIconEmoji !== '';
        const status = this.getStatus(fromAutoResponder, fromWebhook, user);

        return (
            <ProfilePicture
                hasMention={hasMention}
                isRHS={isRHS}
                size={36}
                src={src}
                profileSrc={profileSrc}
                isEmoji={isEmoji}
                status={availabilityStatusOnPosts === 'true' ? status : undefined}
                userId={user?.id}
                showProfilePopover={true}
                channelId={post.channel_id}
                username={user?.username}
                overwriteIcon={overrideIconURL}
                overwriteName={overrideUsername}
                isBot={user?.is_bot}
                fromAutoResponder={fromAutoResponder}
                fromWebhook={fromWebhook}
                onProfilePopoverOpen={this.props.onProfilePopoverOpen}
                onProfilePopoverClose={this.props.onProfilePopoverClose}
            />
        );
    }
}
